import { render, staticRenderFns } from "./ProjectHead.vue?vue&type=template&id=204e3ab0&scoped=true&"
import script from "./ProjectHead.vue?vue&type=script&lang=js&"
export * from "./ProjectHead.vue?vue&type=script&lang=js&"
import style0 from "./ProjectHead.vue?vue&type=style&index=0&id=204e3ab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204e3ab0",
  null
  
)

export default component.exports